// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { withDataFetching } from 'shared/helpers/dataFetching';
import { connect } from 'react-redux';

// redux store
import {
  getMenuData,
  getSSRHeaders,
  getStoreId,
  isMenuFetching as _isMenuFetching,
} from 'shared/store/app/selectors';
import { fetchMenuDataV2 as _fetchMenuData } from 'shared/store/app/services';

// defs
import { IHeadersObject } from 'global';

interface IApiStateProps {
  isMenuFetching: boolean;
  menuData: any;
  storeId: string;
  cookies: {
    [key: string]: string;
  };
  ssrHeaders: IHeadersObject;
}

interface IApiDispatchProps {
  fetchMenuData: typeof _fetchMenuData;
}

interface IApiProps extends IApiStateProps, IApiDispatchProps {
  children: React.ReactNode;
}

function Api({ children, isMenuFetching = true }: IApiProps) {
  if (isMenuFetching) {
    return null;
  }

  return <>{children}</>;
}

const mapStateToProps = (state: any) => ({
  isMenuFetching: _isMenuFetching(state),
  menuData: getMenuData(state),
  storeId: getStoreId(state),
  cookies: state.app.cookies,
  ssrHeaders: getSSRHeaders(state),
});

const mapDispatchToProps = {
  fetchMenuData: _fetchMenuData,
};

const fetchData = ({ fetchMenuData, menuData, storeId = '' }: IApiProps) => {
  if (__BROWSER__ || isEmpty(menuData) === false) {
    return Promise.resolve();
  }
  return fetchMenuData(storeId);
};

export default connect<IApiStateProps, IApiDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(withDataFetching(fetchData)(memo(Api)));
